import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { AnswersOptionsVM, QuestionsVM, QuestionTypes, TrainingCatVM, TrainingInfo, TrainingSlidesVM, TrainingSubSectionsVM } from '../setup-training-types.model';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-training-session',
  templateUrl: './training-session.component.html',
  styleUrls: ['./training-session.component.scss']
})
export class TrainingSessionComponent implements OnInit {
  selectedwith:string= '0%';
  selectedwithNumber:number=0;
  TrainingCategories: TrainingCatVM[];
  TrainingId: number = 0;
  TrainingInfo: TrainingInfo;
  Sections: TrainingSubSectionsVM[];
  Slides: TrainingSlidesVM[];

  SlideInfo: TrainingSlidesVM;
  sessionId: number = 0;
  QuestionTypes: QuestionTypes[];
  TrainingQuestions: QuestionsVM[];

  TrainingQuestions_: QuestionsVM[];


  selectedSlide: string;

  isURL: boolean = false;
  SectionId: number;
  sectionName: string;
  isPrevious: boolean = false;
  isNext: boolean = false;
  isSQuestion: boolean = false;
  sectionSlides: TrainingSlidesVM[];
  currentSlideId: number;
  isSectionQView: boolean = false;
  hasInvalidQ:boolean=false;
  totalClicksCount:number=0;
  constructor(private _dialog: MatDialog, private _route: ActivatedRoute, private _sanitizer: DomSanitizer,private _router: Router,
    private _appService: AppService, private _trainingService: TrainingService,) { }

  ngOnInit() {
    this.sessionId = Number(this._route.snapshot.params.id);
    this.TrainingId = Number(this._route.snapshot.params.id2);
    console.log("TrainingId", this.TrainingId)
    this._appService.setPageTitle('Training Session');
    this.LoadTrainingDetails();
  }
  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

  LoadURL(url: string) {
    console.log(url)
    return this._sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${url}`);
  }



  LoadTrainingDetails() {
    this._trainingService.LoadTraining(this.TrainingId).subscribe(res => {
      console.log("result_tarining sections", res)
      this.TrainingInfo = res;
      this.Sections = this.TrainingInfo.SubTrainings;
      this.Slides = this.TrainingInfo.Slides;
      this.QuestionTypes = this.TrainingInfo.QuestionTypes;
      this.TrainingQuestions_ = this.TrainingInfo.TrainingQuestions;

      //progress bar 
      this.totalClicksCount = this.Slides.length + this.Sections.length;
      let oneclickvalue = Math.round((100/this.totalClicksCount));
      this.TotalCount = this.TotalCount+1;
      this.selectedwithNumber = oneclickvalue *this.TotalCount;
      this.selectedwith = this.selectedwithNumber.toString() + '%';

      //first load
      let copySlides = [...this.Slides];
      this.SectionId = this.Sections[0].TrainigSubId;
      this.sectionName = this.Sections[0].TrainigSubName;

      var filtedredSlides = copySlides.filter(x => x.SubSectionId == this.SectionId);
      this.sectionSlides = copySlides.filter(x => x.SubSectionId == this.SectionId);
      this.currentSlideId = filtedredSlides[0].SlideId;
      this.isURL = filtedredSlides[0].isLink;
      this.selectedSlide = this.isURL == true ? filtedredSlides[0].YoutubeLink : filtedredSlides[0].SlideImage;
      //console.log("isURL", this.isURL, this.selectedSlide)

      let copyQuestions = [...this.TrainingQuestions_];
      var filterQuestions = copyQuestions.filter(x => x.SubSectionId == this.SectionId);
      if (filtedredSlides.length > 0) {
        this.isNext = true;
      }

      if (filterQuestions.length > 0) {
        this.isSQuestion = true;
      }
    });

  }
 
  TotalCount:number=0;
  NextSlide() {
    let index = this.sectionSlides.findIndex(x => x.SlideId == this.currentSlideId)
    let slide = this.sectionSlides[index + 1];
    //console.log("isURL", slide, this.selectedSlide)
    if (slide) {
      this.currentSlideId = slide.SlideId;
      this.isURL = slide.isLink;
      this.selectedSlide = this.isURL == true ? slide.YoutubeLink : slide.SlideImage;
      console.log("isURL", this.isURL, this.selectedSlide)

      let checkNext = this.sectionSlides[index + 2]
      if (checkNext) {
        this.isNext = true;
      } else {
        this.isNext = false;
      }

      this.isPrevious = true;

      let oneclickvalue = Math.round((100/this.totalClicksCount));

      this.TotalCount = this.TotalCount+1;
      this.selectedwithNumber = oneclickvalue *this.TotalCount;
      this.selectedwith = this.selectedwithNumber.toString() + '%';

    }
  }

  PreviousSlide() {
    let index = this.sectionSlides.findIndex(x => x.SlideId == this.currentSlideId)
    let slide = this.sectionSlides[index - 1];
    if (slide) {
      this.currentSlideId = slide.SlideId;
      this.isURL = slide.isLink;
      this.selectedSlide = this.isURL == true ? slide.YoutubeLink : slide.SlideImage;
      console.log("isURL", this.isURL, )

      let checPrev = this.sectionSlides[index - 2]
      if (checPrev) {
        this.isPrevious = true;
      } else {
        this.isPrevious = false;
      }

      this.isNext = true;
      let oneclickvalue = Math.round((100/this.totalClicksCount));
      this.TotalCount = this.TotalCount-1;
      this.selectedwithNumber = oneclickvalue *this.TotalCount;
      this.selectedwith = this.selectedwithNumber.toString() + '%';
    }
  }

  SectionQuestions() {
    this.LoadQuestions();
    this.show=true;
    this.isSectionQView = true;

    let oneclickvalue = Math.round((100/this.totalClicksCount));
    this.TotalCount = this.TotalCount+1;
    this.selectedwithNumber = oneclickvalue *this.TotalCount;
    this.selectedwith = this.selectedwithNumber.toString() + '%';
  }
  TrainingQuestionsCopy:QuestionsVM[];
  LoadQuestions(){
    this._trainingService.LoadQuestionInfForSection(this.SectionId).subscribe(res=>{
      this.TrainingQuestions = res;
      this.TrainingQuestionsCopy = [...this.TrainingQuestions];
      //this.isSectionQView = true;
    })
  }
 isURL_:boolean=false;
 selectedSlide_:string;
  GotoReleventSlide(slideid:number){
    this.showslide=true;
    this.show=false;
    this.sectionSlides.map(x=>{
      if(x.SlideId==slideid){
        this.isURL_ = x.isLink;
        this.selectedSlide_ = this.isURL_ == true ? x.YoutubeLink : x.SlideImage;
        console.log("relevent slide__",x)
      }
    })
  }

  GotPreviousQuestions(){
    this.show=true;
    this.showslide=false;
  }
  showslide:boolean=false;
  show:boolean=false;
  gotoNextSection:boolean=false;
  FinishTrainig:boolean=false;
  SubmitAnswers(){
    //this.show=false;
    console.log("questions", this.TrainingQuestionsCopy)
    //this.hasInvalidQ=false;
    this.TrainingQuestionsCopy.map(q=>{
      q.Invalid=false;
      if(q.QuestionTypeId!=3){
       let isInvalid = q.AnswerList.find(x=>x.Select!=x.UserSelect);
       if(isInvalid)
          q.Invalid=true;
         // this.hasInvalidQ=true
      }
      if(q.QuestionTypeId==3){
        let count =0;
        q.AnswerList.map(x=>{
         if(x.Select==true && x.UserSelect == true){
           count=count+1;
         }
         if(x.Select==false && x.UserSelect == true){
              q.Invalid=true;
              //this.hasInvalidQ=true
          }
        })

        if(count<q.AnswerCount && q.Invalid==false){
          q.Invalid=true;
         // this.hasInvalidQ=true
        }
      }
    })
    let hasInvalidQ = this.TrainingQuestionsCopy.find(x=>x.Invalid==true);
    if(hasInvalidQ){
      this.hasInvalidQ=true
    }else{
      this.hasInvalidQ=false;
      //need to check it has another section
     
      let index = this.Sections.findIndex(x => x.TrainigSubId == this.SectionId)
      let section = this.Sections[index + 1];
      if (section) {
        this.TrainingQuestions =null;
        this.showslide=false;
  this.show=false;
  this.gotoNextSection=false;
  this.FinishTrainig=false;

        console.log("hasSection", section)
        this.SectionId = section.TrainigSubId;
        this.sectionName = section.TrainigSubName;
        let copySlides = [...this.Slides];
        var filtedredSlides = copySlides.filter(x => x.SubSectionId == this.SectionId);
        this.sectionSlides = copySlides.filter(x => x.SubSectionId == this.SectionId);
        this.currentSlideId = filtedredSlides[0].SlideId;
        this.isURL = filtedredSlides[0].isLink;
        this.selectedSlide = this.isURL == true ? filtedredSlides[0].YoutubeLink : filtedredSlides[0].SlideImage;
        console.log("isURL", this.isURL, this.selectedSlide)
  
        let copyQuestions = [...this.TrainingQuestions_];
        var filterQuestions = copyQuestions.filter(x => x.SubSectionId == this.SectionId);
        if (filtedredSlides.length > 0) {
          this.isNext = true;
        }
  
        if (filterQuestions.length > 0) {
          this.isSQuestion = true;
        }


        this.isSectionQView=false;
        //this.gotoNextSection=true;
        console.log("Goto Next Section")

      }else{
        this.FinishTrainig=true;
        this.gotoNextSection=true;
        

        //progress bar 100%
        let oneclickvalue = Math.round((100/this.totalClicksCount));
        this.TotalCount = this.TotalCount+1;
        this.selectedwithNumber = oneclickvalue *this.TotalCount;
        this.selectedwith ='100%';

        //this.isSectionQView=false;
        console.log("Training Done")
      }

      
    
    }
    this.TrainingQuestions = this.TrainingQuestionsCopy;

    
  }

 FinishTraing(){
  this._trainingService.UpdateTrainingSessionComplete(this.sessionId).subscribe(res=>{
    if(res==true){
      this._router.navigate(['training-activity']);
    }
  })
 
 }
  SelectAnswerRadio(selectitem:AnswersOptionsVM,question:QuestionsVM){
    //console.log("event_radio11111", event.target)
    this.TrainingQuestionsCopy.map(q=>{
      if(q.QuestionId==question.QuestionId){

        q.AnswerList.map(x=>{
          if(x.Id==selectitem.Id){
            x.UserSelect=true;
          }else{
            x.UserSelect=false;
          }
        })

      }
    })
  }

  SelectAnswerMutipleSelection(question:QuestionsVM, selectitem:AnswersOptionsVM){
    console.log("event_msq =", selectitem)
    //let copy_ = [...this.TrainingQuestions];
    this.TrainingQuestionsCopy.map(q=>{
      if(q.QuestionId==question.QuestionId){
        q.AnswerList.map(x=>{
          if(x.Id==selectitem.Id){
            x.UserSelect= !x.UserSelect;
          }
        })
      }
    })
   // this.TrainingQuestions = copy_
  }

}
